import { LogOut } from 'lucide-react';
import { useSignOut } from '../../hooks/useSignOut';
import logoImage from '../../assets/920a151e35875b2a6468c8afe0418ba4ce7adc2e.png';

/**
 * 14-05: Landing page for authenticated users with `auth_role='basic_access'`
 * AND `can_clock_in=false` — i.e. they passed the login gate (active staff)
 * but have no CB privileges and no Time PWA access. The page tells them to
 * speak to a Contracts Manager and offers a sign-out button.
 *
 * Routed at top-level `/no-access` (not under Layout) so Layout's me-driven
 * redirect doesn't loop the page back out.
 */
export function NoAccessPage() {
  const { signOut, signingOut, error } = useSignOut();

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md text-center">
        <img src={logoImage} alt="Reprotec" className="h-10 w-auto mx-auto mb-2" />
        <h1 className="text-[15px] text-neutral-600 mb-6">Work</h1>

        <h2 className="text-xl font-semibold text-neutral-900 mb-4">No access yet</h2>

        <p className="text-[13px] text-neutral-700 leading-relaxed mb-8">
          You are logged in, but do not currently have access to any functions, please speak to a
          Contracts Manager.
        </p>

        {error && (
          <p role="alert" className="mb-4 text-[13px] text-red-700">
            {error}
          </p>
        )}

        <button
          type="button"
          onClick={signOut}
          disabled={signingOut}
          className="w-full py-2.5 px-4 rounded-md bg-neutral-100 text-neutral-700 text-[13px] font-medium hover:bg-neutral-200 transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
        >
          <LogOut className="w-4 h-4" />
          {signingOut ? 'Signing out…' : 'Sign out'}
        </button>
      </div>
    </div>
  );
}
